import("../../../../styles/pages/charts/index/index.css")
import("../../../../styles/pages/charts/index/components/offcanvas_stations.css")
import("../../../../styles/components/map/draw_control.css")
import Map from "./components/map/map"
import _station from './_station'
import 'leaflet.pm'
import('leaflet.pm/dist/leaflet.pm.css')

import OffcanvasStations from './components/offcanvas_stations/offcanvas_stations'
import OffcanvasFilter from "./components/offcanvas_filter/offcanvas_filter"
import OffcanvasOptions from "./components/offcanvas_options/offcanvas_options"
import OffcanvasLayerControl from "./components/offcanvas_layer_control/offcanvas_layer_control"
import Chart from './components/chart/chart'
import Arrow from "./components/arrow/arrow"
import UserGuideController from "./components/user_guide/user_guide_controller"
import Supporters from "./components/supporters/supporters"

import Toast from '../../../components/toast/toast'
import filter_view from "./components/offcanvas_filter/filter_view"
import ViewController from "./components/view/view_controller"
import ListController from "./components/view/list/list_controller"
import store from '@packs/pages/charts/index/components/view/edit/store'

let GENERAL_OPTIONS = {
    station_type: undefined,
    station_prefixes: undefined
} 

//pegando parametros da URL
getUrlParams()

let mapComponent = new Map({GENERAL_OPTIONS: GENERAL_OPTIONS})
let userGuideController, offcanvasStations,offcanvasFilter,offcanvasOptions = new OffcanvasOptions({id: "offcanvas_options"}) ,offcanvasLayerControl, chartComponent = new Chart({modal_id: "#modal_chart", chart_id: "chart_container", offcanvasOptions: offcanvasOptions, general_options: GENERAL_OPTIONS}), supporters = new Supporters(),_filter_view, viewController,listControler
moment.locale('pt-br');

$(document).on('station_list:item_click', (e,data)=>{
    if(!data.item.isSelected()){
        if(_station.validateCount(1)){
            //alterando propriedade do objeto
            _station.setStationProp(data.item.getValue(), 'selected', true)
        } else {
            Toast.warning({text: "Erro ao selecionar postos. Número limite é de " + _station.STATIONS_LIMIT})
        }
    } else {
        _station.setStationProp(data.item.getValue(), 'selected', false)
    }

    if(data.item.isSelected()){
        // mapComponent.zoomToMarker(data.item.getValue())
    }
    
})// EVENTO DE CLICK NO TOOLTIPS DO MAPA
$(document).on('tooltip:clicked', (e, data)=>{
    let station_id = data.station_id
    
    if(!_station.getStation(station_id).selected){
        if(_station.validateCount(1)){
            _station.toggleStationProp(station_id, 'selected')    
        } else {
            Toast.warning({text: "Erro ao selecionar postos. Número limite é de " + _station.STATIONS_LIMIT})
        }
    } else {
        _station.toggleStationProp(station_id, 'selected')    
    }

    if(_station.getStation(station_id).selected){
        // mapComponent.zoomToMarker(station_id)
    }

})

// EVENTO GENÉRICO, SEMPRE QUE QUISER SELECIONAR/TIRAR SELEÇÃO DE UM POSTO
$(document).on('stations:select', (e, data)=>{
    let station_id = data.station_id
    let selected = data.selected //boolean

    if(_station.validateCount(1)){
        //alterando propriedade do objeto
        _station.setStationProp(station_id, 'selected', selected)
    }
    
})

//EVENTO GENÉRICO PARA ALTERAR SELEÇÃO DE MULTIPLOS POSTOS
$(document).on('stations:select_multiple', (e, data)=>{

    function generateText(qtd){
        return (qtd > 1) ? qtd + " postos selecionados" : (qtd == 1) ? qtd + " posto selecionado" : "Nenhum posto selecionado"
    }

    let qtd = 0
    let station_ids = data.station_ids
    let select = data.select
    let show_toast = data.show_toast

    if(_station.validateCount(station_ids.length)){
        _station.getAllStations().forEach(station=>{
            if(station_ids.includes(station.id)){
                qtd ++
                station.selected = select
            }
        })
        if(show_toast){
            Toast.show({text: generateText(qtd)})
        }
    } else {//numero de postos selecionados ultrapassaria o limite
        // if(show_toast){
            Toast.warning({text: "Erro ao selecionar postos. Número limite é de " + _station.STATIONS_LIMIT})
        // }
    }
    
})

$(document).on('dom-element-filter:click', e=>{
    offcanvasFilter.show()
})

$(document).on('dom-element-layer:click', e=>{
    offcanvasLayerControl.show()
})

$(document).on('map:zoom-to-markers', e=>{
    mapComponent.zoomToMarkers()
})

$(document).on('dom-element-chart:click', e=>{
    //'validation' fica a validação se conseguiu ou nao gerar o gráfico, com motivos caso nao
    let validation = chartComponent.generateChart()
    if(!validation.status){
        switch(validation.error_id){
            case 1: //falta de postos = abrir offcanvasPostos
                offcanvasStations.toStationList()
                offcanvasStations.show(true)
                break;
            default:
                break;
        }
    } else {
        closeAllOffcanvas()
    }
})

$(document).on('dom-element-config:click', e=>{
    offcanvasOptions.show()
})

$(document).on('dom-element-stations:click', e=>{
    offcanvasStations.toStationList()
    offcanvasStations.show()
})

$(document).on('offcanvas-stations:open', e=>{
    offcanvasStations.toStationList()
    offcanvasStations.show()
})
$(document).on('offcanvas-stations:close', e=>{
    offcanvasStations.hide()
})
$(document).on('offcanvas-options:open', e=>{
    offcanvasOptions.show()
})
$(document).on('offcanvas-options:close', e=>{
    offcanvasOptions.hide()
})

//EVENTO DE FILTRO DO FORMULÁRIO. JÁ COM OS MARCADORES 'VALIDOS'
$(document).on('filtered','.filter-marker-form',function(e,data){
    //lista de markers que passaram no filtro
    let markers = data.markers    

    //exibindo apenas os markers filtrados no mapa
    mapComponent.reloadMarkers(markers)
    
    // _station.showOnlyThose(markers.map(marker=>marker.options.station_id))

    offcanvasStations.filter()
    
    mapComponent.showLayersByFilter(offcanvasFilter.getCurrentFilter())
    
    let current_filter = offcanvasFilter.getCurrentFilter()
    
    //reload na visualização de filtros. SetFilter já chama reload()
    _filter_view.setFilter(current_filter)
    
    //exibindo/escondendo visualização de filtros
    _filter_view.hide(Object.keys(current_filter).length == 0)

    //salvando (caso habilitado) o filtro para próximas sessões
    offcanvasFilter.saveFilter()
})

//clique no botão de localização
$(document).on('dom-element-location:click', e=>{
    //função executada quando localização é recebida com sucesso
    let success = position =>{
        mapComponent.zoomToLocation(L.latLng(position.coords.latitude, position.coords.longitude))
    }
    //função executada quando a localização não é recebida
    let error = () =>{
        Toast.show({text: 'O SIBH não tem permissão para usar seu local :('})
    }
    //tentando pegar localização do navegador
    navigator.geolocation.getCurrentPosition(success, error)
})

//abre os 2 canvas para alteração dos parâmetros de pesquisa. Stations & Options
$(document).on('chart:alter-params', ()=>{
    offcanvasStations.toStationList()
    offcanvasOptions.show()
    offcanvasStations.show()
})

$(document).on('chevron-arrow:click', (e, data)=>{
    if(data.direction == 'left'){
        offcanvasStations.toStationList()
        offcanvasStations.show()
    } else {
        offcanvasOptions.show()
    }
})

$(document).on('form-group::submit-valid', function(e, group){
    offcanvasStations.toGroupList()
    offcanvasStations.show()
})

$(document).on('form-group::invalid-fields', function(e, validation){
    Toast.show({text:validation.message})
})

$(document).on('dom-element-help:click', ()=>{
    userGuideController.open()
})

$(document).on('dom-element-views:click', () =>{
    generateViewComponent()
})

$(document).on('find-location-box:nearby-button::click', (e, data)=>{
    //gerando layer 'circle' representando o radius da seleção dos postos ao redor
    let layer = L.circle(L.latLng(data.lat, data.lng), {radius: parseInt(data.id)*1000, stroke: 'cyan', color: 'cyan'});

    mapComponent.addLayerToFeature(layer, 'draw_group')

    mapComponent.zoomToLayer('draw_group')

    let markers = mapComponent.getNearbyMarkers(L.latLng(data.lat, data.lng), parseInt(data.id)*1000)
    
    $(document).trigger("stations:select_multiple", {station_ids: markers.map(x=>x.options.station_id), select: true, show_toast:true})
})

$(document).on('location-box:your-location::error', ()=>{
    Toast.warning({text:"O SIBH não tem permissão para usar seu local"})
})

$(document).on('map:zoom_to_marker', (e, data) =>{
    let station_prefix_id = data.station_prefix_id
    let station = _station.getStation(station_prefix_id)    
    
    mapComponent.zoomToLocation({lat: station.latitude, lng:station.longitude})
})



$(function(){
    //configurações gerais do highcharts
    setHighchartsOptions()

    //configurando tamanho do mapa de acordo com o espaço disponivel na tela
    setMapContainerSize()
    window.addEventListener('resize', function () {
        setMapContainerSize()
        mapComponent.invalidateSize()
        chartComponent.setSelectStationViewSize()
    })

    

    //gerando offcanvas controle de camadas
    offcanvasLayerControl = new OffcanvasLayerControl({id: "offcanvas_layer_control"})
    offcanvasLayerControl.generate()

    //gerando offcanvas opções de consulta
    offcanvasOptions.generate()

    //gerando o mapa
    mapComponent.generate()

    mapComponent.invalidateSize()

    //exibindo overlay de carregamento de dados no mapa
    mapComponent.showOverlay(true)

    // mapComponent.generateProgressBar()

    //Componente de Views do usuário
    // generateViewComponent()

    

    _station.getStations(GENERAL_OPTIONS.station_type, mapComponent).then(stations=>{
        // console.log(stations);
        
        
        stations.map(x=>x.show = true)
        let STATIONS = {
            list:stations
        }

        let validator = {
            get(obj, key){
                if (typeof obj[key] === 'object' && obj[key] !== null && key != 'marker') {
                    return new Proxy(obj[key], validator)
                } else {
                    return obj[key];
                }
            },
            set(obj, key, value){
                // console.log(obj, key, value);
                obj[key] = value
                
                if(key == 'selected'){
                    let count = _station.countSelected()
                    obj.listItem.update()
                    obj.marker._active(value)
                    offcanvasStations.updateListCounter()
                    chevronArrowLeft.update(count)
                }
                if(key == 'show'){
                    //controlando se o marcador desse posto deve ser exibido ou nao
                    mapComponent.showMarker(obj,value)

                    // //controlando se o listItem deve ser exibido ou não
                    offcanvasStations.showListItem(obj.listItem, value)
                }

                return true
            }
        }

        _station.STATIONS_OBJ = new Proxy(STATIONS, validator)   

        //passando referencia do controlador de postos para controladores interessados
        mapComponent._station = _station.STATIONS_OBJ
        chartComponent._station = _station.STATIONS_OBJ
        

        //gerando markers do mapa baseado na lista de postos
        mapComponent.generateMarkers()

        //gerando offcanvas com postos
        offcanvasStations = new OffcanvasStations({id: "offcanvas_station", station:_station.STATIONS_OBJ, general_options: GENERAL_OPTIONS})
        offcanvasStations.generate()

        //gerando offcanvas filtro
        offcanvasFilter = new OffcanvasFilter({id: "offcanvas_filter", station:_station.STATIONS_OBJ, mapComponent: mapComponent})
        offcanvasFilter.generate()
        
        generateFilterView()

        loadDefaultFilter()

        //gerando chevrons. Mais uma forma de abrir offcanvas
        let chevronArrowRight = new Arrow({title: "Opções de Consulta", direction: 'right'})
        let chevronArrowLeft = new Arrow({title: "Selecionar Postos", direction: 'left'})
        chevronArrowRight.generate()
        chevronArrowLeft.generate()

        generateUserGuide()

        //verificando se foi passado algo para automatização do processo. Como data, prefixos, etc..
        checkUrlParams()

        //invalidateSize do mapa
        setTimeout(_=>{
            mapComponent.showOverlay(false)
            mapComponent.invalidateSize()
            mapComponent.zoomToMarkers()
            
        },1000)

        
        //escondendo overlay de carregamento de dados no mapa
        // mapComponent.showOverlay(false)
        
        //gerando componente de apoiadores
        supporters.generate()

        chartComponent.on('edit-param', param_id =>{
            console.log(param_id)
        })

    })
    
})

function generateUserGuide(){
    userGuideController = new UserGuideController()
    userGuideController.generate()
}

const setMapContainerSize = () =>{
    const HEADER_SIZE = $("#main_header").outerHeight();
    const FOOTER_SIZE = $("#main_footer").outerHeight();
    const BREADCRUMB_SIZE = $(".container-breadcrumb").outerHeight();
    $("section").removeClass("pb-2");
    $("section").addClass("p-0");
    $("section").css("height", (window.innerHeight - HEADER_SIZE - FOOTER_SIZE - BREADCRUMB_SIZE ));
    $("section").css("min-height", (window.innerHeight - HEADER_SIZE - FOOTER_SIZE - BREADCRUMB_SIZE));

    //invalidateSize do mapa
    mapComponent.invalidateSize()
}

function closeAllOffcanvas(){
    offcanvasStations.hide()
    offcanvasFilter.hide()
    offcanvasLayerControl.hide()
    offcanvasOptions.hide()   
}

function getUrlParams(){
    let url = new URL(window.location.href)
    GENERAL_OPTIONS.station_type = url.searchParams.get("station_type") || "plu"
    GENERAL_OPTIONS.station_prefixes = url.searchParams.getAll("station_prefixes[]") || []
    GENERAL_OPTIONS.start_date = url.searchParams.get("start_date") || undefined
    GENERAL_OPTIONS.end_date = url.searchParams.get("end_date") || undefined

    
}

function checkUrlParams(){
    //verificando se tem prefixo
    // console.log(GENERAL_OPTIONS);
    if(GENERAL_OPTIONS.station_prefixes.length > 0){

        //pegando os ids dos prefixos
        let station_prefix_ids = _station.getStationByPrefix(GENERAL_OPTIONS.station_prefixes).map(x=>x.id)

        //trigger evento para seleção dos postos
        $(document).trigger("stations:select_multiple", {station_ids: station_prefix_ids, select: true, show_toast:false})

        if(GENERAL_OPTIONS.start_date && GENERAL_OPTIONS.end_date){
            offcanvasOptions.form().setDate(GENERAL_OPTIONS.start_date, GENERAL_OPTIONS.end_date)
        }

        //gerando gráfico
        $(document).trigger("dom-element-chart:click")
    }
}

function setHighchartsOptions(){
    var timezone = new Date().getTimezoneOffset()
    Highcharts.setOptions({
      time: {
          timezoneOffset: timezone
      },
      lang: {
          months: moment.months(),
          shortMonths: moment.monthsShort()
      }
    });
  }

  function loadDefaultFilter(){
    if(localStorage && localStorage.getItem('sibh_charts_default_filter')){
        let filter_options = localStorage.getItem('sibh_charts_default_filter')
        try{
            filter_options = JSON.parse(filter_options)
            offcanvasFilter.filterMakers(filter_options)
        } catch(e){
            console.log('Erro ao utilizar o localstorage com o filtro padrão');
            localStorage.removeItem('sibh_charts_default_filter')
        }
    } else {
        offcanvasFilter.filterMakers({transmission_status_id: ['ok']})
    }
    
  }

  function generateFilterView(){
    //gerando componente para visualizar filtros no mapa
    _filter_view = new filter_view()
    _filter_view.generate()
    
    $(_filter_view).on('clear-filter-option', (e,data)=>{
        offcanvasFilter.filterMakers({[data.option]: []})
    })
  }

  function generateViewComponent(){
    let chartViewComponent = new Chart({modal_id: "#modal_view_chart", chart_id: "chart_view_container", offcanvasOptions: offcanvasOptions, general_options: GENERAL_OPTIONS})

    //workaround
    chartViewComponent._station.list = []
    
    viewController = new ViewController()
    viewController.showList()

    //ao clicar no botao de 'use' da view na lista de views
    viewController.on('use_view', parameter=>{
        chartViewComponent.generateView(parameter, store.getPeriod())
        store.setProgresBarOptions(parameter.values.progress_bar || {options:{}})
    })

    //ao clicar no botão de configuração dentro da view já exibida
    chartViewComponent.on('edit-param', param_id=>{
        viewController.showEdit({id: param_id})
    })

    //ao clicar no botão de fechar dentro da view
    chartViewComponent.on('close', _ =>{
        $("#modal_view_chart").modal('hide')

        //destruindo charts
        chartViewComponent.destroyAllCharts()

        //exibindo lista de views
        viewController.showList()
    })
  }